import { createContext, useEffect, useState } from 'react';
import { useLocation } from "react-router-dom"

export const ContextAplicacion = createContext();

export const AplicacionesContext = ({ children }) => {

    const location = useLocation();

    const [ selectAplicacionDoc, setselectAplicacionDoc] = useState([]);
    const [ selectAplicacionCxc, setselectAplicacionCxc ] = useState([]);
    const [ selectAplicaionLeasing, setselectAplicaionLeasing ] = useState([]);
    const [ rowsLeasing, setRowsLeasing ] = useState({
      columns:[],
      rows: [],
      tempRows: []
    });

    const [ rowsDoc, setRowsDoc ] = useState({
      columns:[],
      rows: [],
      tempRows: []
    });
    
    const [ rowsCxc, setRowsCxc ] = useState({
      columns:[],
      rows: [],
      tempRows: []
    })

    const [totalAplicaciones, setTotalAPlicaciones ] = useState({
        doc:0,
        cxc:0,
        cuotas:0
    });

    const [ totalAplicacionestable, setTotalAplicacionestable ] = useState(0);

    useEffect(()=>{
        if( location.pathname.split('/')[1] != 'autoatencion' ){
            setselectAplicacionDoc([]);
            setselectAplicacionCxc([]);
            setselectAplicaionLeasing([]);
            setRowsLeasing({
                columns:[],
                rows: [],
                tempRows: []
            })
            setRowsDoc({
                columns:[],
                rows: [],
                tempRows: []
            })
            setRowsCxc({
                columns:[],
                rows: [],
                tempRows: []
            })
            setTotalAPlicaciones({
                doc:0,
                cxc:0,
                cuotas:0
            })
            setTotalAplicacionestable(0)
        }
    },[location])

  return (
    <ContextAplicacion.Provider value={
        { 
            selectAplicacionDoc, 
            setselectAplicacionDoc,
            selectAplicacionCxc, 
            setselectAplicacionCxc,
            selectAplicaionLeasing, 
            setselectAplicaionLeasing,
            rowsLeasing, 
            setRowsLeasing,
            rowsDoc, 
            setRowsDoc,
            rowsCxc, 
            setRowsCxc,
            totalAplicaciones, 
            setTotalAPlicaciones,
            totalAplicacionestable, 
            setTotalAplicacionestable
        }
    }>
      {children}
    </ContextAplicacion.Provider>
  );
};